import { IconButton, Popover } from "@material-ui/core";
import { HelpIcon } from "../Icons/HelpIcon";
import React, { PropsWithChildren, useRef, useState } from "react";
import { Close } from "@material-ui/icons";

interface HelpPopoverProps {
  popoverId: string;
  title?: string;
}

export const HelpPopover = (props: PropsWithChildren<HelpPopoverProps>) => {
  const { popoverId, title, children } = { ...props };
  const icon = useRef<HTMLButtonElement>(null);
  const [showHelp, setShowHelp] = useState(false);

  return (
    <>
      <IconButton
        ref={icon}
        aria-controls={popoverId}
        aria-haspopup="true"
        aria-expanded={showHelp}
        size="small"
        onClick={(e) => {
          setShowHelp(true);
          e.stopPropagation();
        }}
      >
        <HelpIcon className="p-1" />
      </IconButton>
      <Popover
        id={popoverId}
        anchorEl={icon.current}
        open={showHelp}
        onClose={() => setShowHelp(false)}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          style: {
            borderRadius: ".5rem",
          },
        }}
      >
        <div className="p-4 w-96">
          {title ? (
            <>
              <div className="flex">
                <div className="italic flex-grow">{title}</div>
                <IconButton size="small" onClick={() => setShowHelp(false)}>
                  <Close />
                </IconButton>
              </div>
              <hr className="my-2" />
              {children}
            </>
          ) : (
            <div className="flex">
              <div className="flex-grow">{children}</div>
              <IconButton
                className="self-start"
                size="small"
                onClick={() => setShowHelp(false)}
              >
                <Close />
              </IconButton>
            </div>
          )}
        </div>
      </Popover>
    </>
  );
};
